/* eslint-disable camelcase */
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from "typeorm";
import { Alert } from "./reg_alerts.entity";

@Entity("reg_alerts_attributes")
export class AlertAttribute {

  @PrimaryGeneratedColumn("uuid")
    id_alert_attribute?: string;

  @ManyToOne(() => Alert, (alert) => alert.attributes, { nullable: false })
  @JoinColumn({ name: "id_alert_fk" })
    alert?: Alert;

  @Column({ type: "varchar", length: 100, nullable: false })
    attribute_key?: string;

  @Column({ type: "varchar", length: 500, nullable: false })
    attribute_value?: string;

  @Column({ type: "varchar", length: 20, nullable: false })
    data_type?: string;

  @CreateDateColumn({ default: "(now() at time zone 'utc')" })
    registration_date?: Date;

}
